import { render, staticRenderFns } from "./NCFList.vue?vue&type=template&id=6ac5c96a&scoped=true&"
import script from "./NCFList.vue?vue&type=script&lang=js&"
export * from "./NCFList.vue?vue&type=script&lang=js&"
import style0 from "./NCFList.vue?vue&type=style&index=0&id=6ac5c96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5c96a",
  null
  
)

export default component.exports